import React, { useState } from "react";
import { Table, Button, Space, Form, Input, InputNumber, Image } from "antd";
import Modal from "../../components/Modal";

export default function Banner() {
  //模态框是否展示
  const [isModalOpen, setIsModalOpen] = useState(false);
  //点击模态取消按钮
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  //模态打开时的默认值
  const [defaultValues, setDefaultValues] = useState({});
  //当前banner表头
  const currentColumns = [
    {
      title: "排序",
      dataIndex: "order",
      key: "order",
    },
    {
      title: "图片预览",
      dataIndex: "img",
      key: "img",
      render: (img) => <Image width={300} src={img} />,
    },
    {
      title: "图片链接",
      dataIndex: "url",
      key: "url",
    },
    {
      title: "路由",
      dataIndex: "route",
      key: "route",
    },
    {
      title: "可见性",
      dataIndex: "visible",
      key: "visible",
    },
    {
      title: "操作",
      dataIndex: "opeartion",
      key: "opeartion",
      render: (_, record) => (
        <Space>
          <Button type="primary" onClick={() => handleModal(record)}>
            修改
          </Button>
          <Button>删除</Button>
        </Space>
      ),
    },
  ];
  //历史banner表头
  const historyColumns = [
    {
      title: "图片预览",
      dataIndex: "img",
      key: "img",
      render: (img) => <Image width={300} src={img} />,
    },
    {
      title: "图片链接",
      dataIndex: "url",
      key: "url",
    },
    {
      title: "路由",
      dataIndex: "route",
      key: "route",
    },
    {
      title: "可见性",
      dataIndex: "visible",
      key: "visible",
    },
    {
      title: "操作",
      dataIndex: "opeartion",
      key: "opeartion",
      render: (_, record) => (
        <div>
          <Button type="primary" onClick={() => handleModal(record)}>
            修改
          </Button>
        </div>
      ),
    },
  ];
  //全部banner数据
  const data = [
    {
      key: "1",
      order: 1,
      img: "https://s2.loli.net/2023/07/25/CaH71oAjkV4PvIR.png",
      url: "https://s2.loli.net/2023/07/25/CaH71oAjkV4PvIR.png",
      route: "/",
      visible: "是",
    },
    {
      key: "2",
      order: 2,
      img: "https://s2.loli.net/2023/07/25/CaH71oAjkV4PvIR.png",
      url: "https://s2.loli.net/2023/07/25/CaH71oAjkV4PvIR.png",
      route: "/",
      visible: "否",
    },
  ];
  //点击修改按钮
  const handleModal = (record) => {
    setIsModalOpen(true);
    setDefaultValues(record);
    console.log(record);
  };
  //添加banner
  const handleAdd = () => {
    setDefaultValues({});
    setIsModalOpen(true);
  };
  //表单提交成功
  const onFinish = (value) => {
    //上传表单操作...
    console.log("Success:", value);
    //关闭模态
    setIsModalOpen(false);
  };
  //表单提交失败
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div style={{ padding: 20 }}>
      {/* 当前banner */}
      <Space>
        <h2>当前banner</h2>
        <Button type="primary" onClick={handleAdd}>
          添加
        </Button>
      </Space>
      <Table
        columns={currentColumns}
        dataSource={data.filter((item) => item.visible === "是")}
        pagination={{
          position: ["none"],
        }}
      />
      {/* 历史banner */}
      <h2 style={{ marginTop: 40 }}>历史banner</h2>
      <Table
        columns={historyColumns}
        dataSource={data.filter((item) => item.visible === "否")}
        pagination={{
          position: ["none"],
        }}
      />
      {/* 模态框是否显示 */}
      {isModalOpen && (
        <Form
          name="change"
          initialValues={defaultValues}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Modal
            title="banner配置"
            cancel={handleCancel}
            content={
              <>
                <Form.Item
                  label="可见性"
                  name="visible"
                  rules={[
                    {
                      required: true,
                      message: "请选择可见性",
                    },
                  ]}
                >
                  <select
                    style={{
                      height: 32,
                      padding: "4px 11px",
                      border: "1px solid #d9d9d9",
                      borderRadius: 4,
                      outline: "none",
                    }}
                  >
                    <option value="是">是</option>
                    <option value="否">否</option>
                  </select>
                </Form.Item>
                <Form.Item
                  label="排序"
                  name="order"
                  rules={[
                    {
                      required: true,
                      message: "请输入排序",
                    },
                  ]}
                >
                  <InputNumber min="1" />
                </Form.Item>
                <Form.Item
                  label="图片链接"
                  name="url"
                  rules={[
                    {
                      required: true,
                      message: "请输入图片链接",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="路由"
                  name="route"
                  rules={[
                    {
                      required: true,
                      message: "请输入路由",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </>
            }
          />
        </Form>
      )}
    </div>
  );
}
